import { IStorageBillingInvoices } from 'types/billing.types';
import { IProductList } from 'types/orders';
import { IlogisticServiceDetails } from 'types/services';

export type TInvoiceSectionVariant = 'order' | 'logistic-service' | 'storage';

export const INVOICE_SECTION_VARIANT = {
  ORDER: 'order',
  LOGISTIC_SERVICE: 'logistic-service',
  STORAGE: 'storage'
} as const;

export interface IInvoiceRecord {
  id?: number | null;
  invoiceNumber?: string | null;
  invoiceEmissionDate?: string | null;
  invoiceUrl?: string | null;
  type?: TInvoiceSectionVariant;
}

export interface IInvoiceOrderRecord extends IInvoiceRecord {
  orderId?: number | null;
  order?: IProductList | null;
}

export interface IInvoiceLogisticServiceRecord extends IInvoiceRecord {
  logisticServiceId?: number | null;
  logisticService?: IlogisticServiceDetails | null;
}

export interface IInvoiceStorageRecord extends IInvoiceRecord {
  storageInvoiceId?: number | null;
  storageInvoice?: IStorageBillingInvoices | null;
}
